


interface MessageIconProps {
	className?: string,
}


const MessageIcon = (props: MessageIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-message-icon"
			className={`svg-inline--fa fa-custom-message-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 535 512">
			<path fill="currentColor" d="m498.26,109.54l-35.11,0l0,231.54c0,24.89 -19.12,45.07 -42.7,45.07l-292.64,0l0,23.27c0,21.81 16.75,39.49 37.42,39.49l287.36,0c10.33,0 20.2,4.51 27.27,12.45l42.81,48.1c4.67,5.24 13,1.76 13,-5.43l0,-354.99c0,-21.81 -16.75,-39.49 -37.42,-39.49l0.01,-0.01z"/>
			<path fill="currentColor" d="m454.94,334.5l0,-290.45c0,-24.33 -18.69,-44.05 -41.74,-44.05l-371.46,0c-23.05,0 -41.74,19.72 -41.74,44.05l0,395.99c0,8.02 9.3,11.91 14.5,6.06l47.76,-53.66c7.89,-8.86 18.9,-13.89 30.42,-13.89l320.53,0c23.05,0 41.74,-19.72 41.74,-44.05l-0.01,0z"/>
		</svg>
	);
};

export default MessageIcon;